import { render } from "./event-delegated-channel-inviting.vue?vue&type=template&id=6a4959b6&lang=pug"
import script from "./event-delegated-channel-inviting.vue?vue&type=script&lang=js"
export * from "./event-delegated-channel-inviting.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__